/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassSwapErrorCode {
  PASS_NOT_FOUND = 'pass_not_found',
  CURRENT_PASS_ORDER_PAGE_NOT_FOUND = 'current_pass_order_page_not_found',
  TARGET_PASS_ORDER_PAGE_NOT_FOUND = 'target_pass_order_page_not_found',
  TARGET_PASS_ORDER_PAGE_ARCHIVED = 'target_pass_order_page_archived',
  ALREADY_ON_TARGET_PASS_ORDER_PAGE = 'already_on_target_pass_order_page',
  PASS_NOT_ACTIVE = 'pass_not_active',
  PASS_PAUSED = 'pass_paused',
  CANCELLATION_SCHEDULED = 'cancellation_scheduled',
  CURRENT_PASS_ORDER_PAGE_NOT_RECURRING = 'current_pass_order_page_not_recurring',
  TARGET_PASS_ORDER_PAGE_NOT_RECURRING = 'target_pass_order_page_not_recurring',
  NO_ACTIVE_SUBSCRIPTION = 'no_active_subscription',
  NO_CYCLE_END_DATE = 'no_cycle_end_date',
  SCHEDULE_SELECTIONS_REQUIRED = 'schedule_selections_required',
  SCHEDULE_SELECTIONS_NOT_ALLOWED = 'schedule_selections_not_allowed',
  SCHEDULE_SELECTIONS_COUNT_MISMATCH = 'schedule_selections_count_mismatch',
  DUPLICATE_SCHEDULE_SELECTION = 'duplicate_schedule_selection',
  SLOT_NOT_IN_SCHEDULE = 'slot_not_in_schedule',
  SLOT_NOT_REDEEMABLE = 'slot_not_redeemable',
  SLOT_AT_CAPACITY = 'slot_at_capacity',
  TARGET_PASS_ORDER_PAGE_MISCONFIGURED = 'target_pass_order_page_misconfigured',
  NO_PENDING_SWAP = 'no_pending_swap',
  PROVIDER_REJECTED_PRICE_UPDATE = 'provider_rejected_price_update',
  PROVIDER_UNREACHABLE = 'provider_unreachable',
}
